import React from "react";
import PropTypes from "prop-types";
import { Link, graphql, StaticQuery } from "gatsby";

class MapsMenuListTemplate extends React.Component {
  render() {
    const { data } = this.props;
    const { edges: posts } = data.allMarkdownRemark;

    return (
      <div className="content">
        <ul className="no-bullets">
          {posts &&
            posts.map(({ node: post }) => (
              <li key={post.id}>
                <Link
                  className="title has-text-primary is-size-4"
                  to={post.fields.slug}
                >
                  {post.frontmatter.title}
                </Link>
              </li>
            ))}
        </ul>
      </div>
    );
  }
}

MapsMenuList.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export default function MapsMenuList() {
  return (
    <StaticQuery
      query={graphql`
        query MapsMenuListQuery {
          allMarkdownRemark(
            sort: { frontmatter: { meta: { sortOrder: ASC } } }
            filter: { frontmatter: { templateKey: { eq: "maps-menu-page" } } }
          ) {
            edges {
              node {
                id
                fields {
                  slug
                }
                frontmatter {
                  title
                }
              }
            }
          }
        }
      `}
      render={(data, count) => (
        <MapsMenuListTemplate data={data} count={count} />
      )}
    />
  );
}
